// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { getRedirectingToRedirectUrl, getRedirectingToPublishYourCv } from '../../selectors';
import { redirectRedirectingTo } from '../../actions';
import LayoutRedirectingTo from '.';
import LayoutRedirectingToPublishYourCv from './indexPublishYourCv';
import { getVerticalName } from '~/common/selectors/config';
import {
  getPublishYourCvUrl,
  publishYourCvSourceNameSelector,
  getPublishYourCvSourceImage,
} from '~/common/selectors/trovit';

type Props = {
  verticalName: string,
  redirectUrl?: string,
  isPublishYourCv?: boolean,
  redirectToSource: Function,
  publishYourCvUrl: ?string,
  publishYourCvSourceName: ?string,
  publishYourCvSourceImage: ?string,
};

type MapDispatchToProps = {
  redirectToSource: Function,
};

type MapStateToProps = {
  verticalName: string,
  redirectUrl?: string,
  publishYourCvUrl: ?string,
  publishYourCvSourceName: ?string,
  publishYourCvSourceImage: ?string,
};

class LayoutRedirectingToComponent extends React.Component<Props> {
  static defaultProps = {
    redirectUrl: '',
    isPublishYourCv: false,
  };

  componentDidMount(): void {
    const { redirectToSource, redirectUrl } = this.props;

    redirectToSource(redirectUrl);
  }

  render(): React.Node {
    return this.props.isPublishYourCv ? (
      <LayoutRedirectingToPublishYourCv {...this.props} />
    ) : (
      <LayoutRedirectingTo {...this.props} />
    );
  }
}

const mapDispatchToProps: MapDispatchToProps = {
  redirectToSource: redirectRedirectingTo,
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    verticalName: getVerticalName(state),
    redirectUrl: getRedirectingToRedirectUrl(state),
    isPublishYourCv: getRedirectingToPublishYourCv(state),
    publishYourCvUrl: getPublishYourCvUrl(state),
    publishYourCvSourceName: publishYourCvSourceNameSelector(state),
    publishYourCvSourceImage: getPublishYourCvSourceImage(state),
  };
}

const LayoutRedirectingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutRedirectingToComponent);

export default LayoutRedirectingContainer;



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/components/RedirectingToLayout/container.js